var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.25 12.75L2.25 15.75M9.75 2.25C8.1587 2.25 6.63258 2.88214 5.50736 4.00736C4.38214 5.13258 3.75 6.6587 3.75 8.25C3.75 9.8413 4.38214 11.3674 5.50736 12.4926C6.63258 13.6179 8.1587 14.25 9.75 14.25C11.3413 14.25 12.8674 13.6179 13.9926 12.4926C15.1179 11.3674 15.75 9.8413 15.75 8.25C15.75 6.6587 15.1179 5.13258 13.9926 4.00736C12.8674 2.88214 11.3413 2.25 9.75 2.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirSearch);
export default __webpack_public_path__ + "static/media/iconoir_search.752f1e7c0686cbf72d0cbc7d31062b52.svg";
export { ForwardRef as ReactComponent };